module.exports = __webpack_public_path__ + "static/media/wallet-solid.3cfe8f20.svg";